import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate } from "react-router-dom";
import { Feedback } from "./Feedback";
import { About } from "./About";
import { ProductDetail } from "./ProductDetail";
import { NotFound } from "./NotFound";
import { Products } from "./Products";
import { ViewCartProducts } from "./ViewCartProducts";
export var mainContentId = "main-content-page-layout";
export function AppRoutes() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { replace: true, to: "/products" }) }), _jsx(Route, { path: "/products", element: _jsx(Products, {}) }), _jsx(Route, { path: "/products/:productId", element: _jsx(ProductDetail, {}) }), _jsx(Route, { path: "/feedback", element: _jsx(Feedback, {}) }), _jsx(Route, { path: "/about", element: _jsx(About, {}) }), _jsx(Route, { path: "/cart", element: _jsx(ViewCartProducts, {}) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }));
}
